import React, { useState, useEffect, useRef } from 'react';

export function SuccessSheet({ isVisible, onClose, onGoToKeys, successData = null}) {
    const [startY, setStartY] = useState(null);
    const [currentY, setCurrentY] = useState(null);
    const sheetRef = useRef(null);
    const timerRef = useRef(null);

    // Блокируем прокрутку body при открытии шторки
    // useEffect(() => {
    //     if (isVisible) {
    //         document.body.style.overflow = 'hidden';
    //         document.body.classList.add('sheet-open');
    //     } else {
    //         document.body.style.overflow = '';
    //         document.body.classList.remove('sheet-open');
    //     }
    //
    //     return () => {
    //         document.body.style.overflow = '';
    //         document.body.classList.remove('sheet-open');
    //     };
    // }, [isVisible]);

    // Автоматическое закрытие через 3 секунды (опционально)

    const handleTouchStart = (e) => {
        setStartY(e.touches[0].clientY);
    };

    const handleTouchMove = (e) => {
        if (startY === null) return;

        const currentTouchY = e.touches[0].clientY;
        const diff = currentTouchY - startY;

        if (diff > 0) {
            e.preventDefault();
            setCurrentY(diff);

            if (sheetRef.current) {
                const maxTranslate = window.innerHeight * 0.5;
                const translateY = Math.min(diff, maxTranslate);
                sheetRef.current.style.transform = `translateY(${translateY}px)`;
            }
        }
    };

    const handleTouchEnd = () => {
        if (startY === null) return;

        const diff = currentY || 0;

        if (diff > 100) {
            onClose();
        }

        if (sheetRef.current) {
            sheetRef.current.style.transform = '';
        }

        setStartY(null);
        setCurrentY(null);
    };

    const handleMouseDown = (e) => {
        setStartY(e.clientY);

        const handleMouseMove = (e) => {
            if (startY === null) return;

            const diff = e.clientY - startY;

            if (diff > 0) {
                setCurrentY(diff);

                if (sheetRef.current) {
                    const maxTranslate = window.innerHeight * 0.5;
                    const translateY = Math.min(diff, maxTranslate);
                    sheetRef.current.style.transform = `translateY(${translateY}px)`;
                }
            }
        };

        const handleMouseUp = () => {
            const diff = currentY || 0;

            if (diff > 100) {
                onClose();
            }

            if (sheetRef.current) {
                sheetRef.current.style.transform = '';
            }

            setStartY(null);
            setCurrentY(null);

            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };

        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
    };

    const handleGoToKeys = () => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }
        onGoToKeys();
        onClose();
    };

    const handleClose = () => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }
        onClose();
    };
    const isRenew = successData?.type === 'renew';
    return (
        <div className={`confirmation-sheet-wrapper ${isVisible ? 'visible' : ''}`}>
            <div
                className="sheet-overlay"
                onClick={handleClose}
                style={{
                padding: '0 0 0 0'
                }}
            />

            <div
                ref={sheetRef}
                className="confirmation-sheet"
            >
                <div className="sheet-content success">
                    <div
                        className="sheet-drag-handle"
                        onTouchStart={handleTouchStart}
                        onTouchMove={handleTouchMove}
                        onTouchEnd={handleTouchEnd}
                        onMouseDown={handleMouseDown}
                    >
                        <div className="drag-indicator" />
                    </div>

                    {/*<div className="icon-placeholder">*/}
                    {/*    <div className="icon-circle" style={{ backgroundColor: '#32d755' }}>*/}
                    {/*        <span style={{ fontSize: '28px' }}>✓</span>*/}
                    {/*    </div>*/}
                    {/*</div>*/}

                    <h3 className="sheet-title" style={{ color: '#32d755' }}>
                        {isRenew ? 'Продление успешно!' : 'Готово!'}
                    </h3>

                    {/* Текст уведомления */}
                    <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                        <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: '16px' }}>
                            {isRenew
                                ? `Ключ #${successData.keyNumber} продлён на ${successData.months} месяцев`
                                : 'VPN ключ успешно создан'
                            }
                        </p>
                    </div>

                    {/* Блок с информацией */}
                    <div className="custom-content-box" style={{
                        background: 'linear-gradient(40deg, rgba(64, 82, 73, 0.3) 50%, #2a5a3a 100%)',
                        borderRadius: '16px',
                        padding: '20px 16px',
                        marginBottom: '24px',
                        border: 'none'
                    }}>
                        <p style={{ color: '#ffffff', fontSize: '16px', textAlign: 'center', margin: 0 }}>
                            В разделе "Управление" вы найдете ваш ключ и приложения
                        </p>
                    </div>

                    {/* Кнопки */}
                    <div className="sheet-buttons">
                        <button
                            className="sheet-button sheet-button-cancel"
                            onClick={handleClose}
                        >
                            Закрыть
                        </button>
                        <button
                            className="sheet-button btn-green"
                            onClick={handleGoToKeys}
                        >
                            Перейти к ключу
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}